import request from '#/utils/request';
import { parseVer4ListResponse } from '#/api/adapters/envelope';
import { listQueryToApiParams } from '#/utils/listUrl/parseListSearchParams';

/**
 * 客戶列表。
 * `GET /crm/customer` — Ver4 list envelope。
 *
 * @param {object} listQuery
 */
export async function fetchCustomerList(listQuery) {
  const { data: raw } = await request.get('/crm/customer', {
    params: listQueryToApiParams(listQuery),
  });
  return parseVer4ListResponse(raw);
}
